/*
getSessionNewTitle.js
获取新的会话主题
 */

import BaseURL from "./BaseURL";

const getSessionNewTitle = async ({query = ''}) => {
    try {
        const response = await BaseURL.post('api/title/', {query: query});
        const response_data = response.data;
        return response_data.title;
    } catch (error) {
        console.log(error)
    }
};

export default getSessionNewTitle;